import HttpClient from "../http/http_client";
export const getAllSponsorAdvertisementRequest = async () => {
  try {
    const response = await HttpClient.get(`sponsor-advertisement/`);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    if (error.response) {
      const { status, data } = error.response;
      return {
        success: false,
        status: status,
        errors: data?.errors || null,
      };
    }
    return {
      success: false,
      status: null,
      errors: "Something went wrong. Please try again.",
    };
  }
};


export const getSponsorAdvertisementByIdRequest = async (id) => {
    try {
        const response = await HttpClient.get(`sponsor-advertisement/${id}`);
        return {
            success : true,
            data : response.data,
        }
    } catch (error) {
        if (error.response) {
            const {status, data} = error.response;
            return {
                success : false,
                status : status,
                errors : data?.errors || null,
            }
        }

        return {
            success : false,
            status : null,
            errors : "Something went wrong. Please try again."
        };
    }
};